import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { BanjoString } from '@stashinvest/react-banjo';
import { Text } from '@stashinvest/react-components';
import { PrimaryButton } from '@stashinvest/ui';

export const RESTRICTED_USER_ERROR_CODE = 24;

const LinkBankRestricted = ({ linkType }) => {
	const history = useHistory();

	return (
		<>
			<Text textStyle="headerSmall" className="mb-contentXS" textAlign="center">
				<BanjoString stringId="information/error/unableToLinkBank" />{' '}
			</Text>
			<Text textAlign="center" textStyle="bodyMediumStandard" className="mt-content2XS">
				<BanjoString stringId="information/giveContext/lockGeneric" />
			</Text>
			<PrimaryButton
				className="my-contentMedium"
				onClick={() => {
					history.push('/');
				}}
			>
				<BanjoString stringId={'action/progress/dismissMessage'} />
			</PrimaryButton>
		</>
	);
};

LinkBankRestricted.propTypes = {
	linkType: PropTypes.string,
};

export default LinkBankRestricted;
